import { render, staticRenderFns } from "./PersonProfilePidPendingNearMatchOverview.vue?vue&type=template&id=f54f7b22&scoped=true&"
import script from "./PersonProfilePidPendingNearMatchOverview.vue?vue&type=script&lang=js&"
export * from "./PersonProfilePidPendingNearMatchOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54f7b22",
  null
  
)

export default component.exports